/*
 * @Author: 林逸飞
 * @Date: 2024-10-10 11:08:22
 * @LastEditors: 林逸飞
 * @LastEditTime: 2024-10-10 16:26:27
 * @FilePath: \pbiot-eam-webd:\lyf\code\demo\src\main.js
 */
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import "./assets/styles/custom.scss";
import router from "./router";
import store from "./store";
import VScaleScreen from "v-scale-screen";

Vue.use(VScaleScreen);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
